"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const utils_1 = require("@obvio/utils");
const toArray_1 = __importDefault(require("rc-util/lib/Children/toArray"));
const react_1 = require("react");
const components_1 = require("./SelectInput/components");
const SelectInputButton_1 = require("./SelectInput/SelectInputButton");
const SelectInputContext_1 = require("./SelectInput/SelectInputContext");
const SelectInputOption_1 = require("./SelectInput/SelectInputOption");
const utils_2 = require("./utils");
const aria_1 = require("./utils/aria");
const Button_1 = require("../../Button");
const Dropdown_1 = require("../../Dropdown");
const Stack_1 = require("../../Stack");
const defaultDropdownStyle = (0, app_1.css) `
  max-height: 300px;
  overflow: auto;
`;
const getSelectorRender = (choices, defaultValue, dropdownCss) => (_a) => {
    var _b, _c;
    var { value = defaultValue, onChange, onBlur, onFocus, hasError, label, success, className, dropdownProps, prefix: _prefix, suffix: _suffix, optional, removable } = _a, props = __rest(_a, ["value", "onChange", "onBlur", "onFocus", "hasError", "label", "success", "className", "dropdownProps", "prefix", "suffix", "optional", "removable"]);
    const id = (0, app_1.useCuid)();
    const [focus, setFocus] = (0, react_1.useState)(false);
    const disabled = Boolean(props.disabled);
    const handleChange = (0, react_1.useCallback)((choice) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(choice);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(choice);
    }, [onChange, onBlur]);
    const choiceLabel = (_c = (_b = (0, toArray_1.default)(choices).find((choice) => choice.props.value === value)) === null || _b === void 0 ? void 0 : _b.props.children) !== null && _c !== void 0 ? _c : '';
    const contextValue = (0, react_1.useMemo)(() => ({ onChange: handleChange, value }), [handleChange, value]);
    const dropdownStyle = (0, react_1.useMemo)(() => {
        return (0, app_1.css) `
        ${defaultDropdownStyle}
        ${dropdownCss}
      `;
    }, []);
    const labelStyle = (0, react_1.useMemo)(() => (0, app_1.css) `
        ${Boolean(value) && components_1.labelOffsetStyle}
      `, [value]);
    const choicesRenderer = (0, react_1.useCallback)(() => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: react_1.Children.map(choices, (choice, i) => ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: choice }, (choice === null || choice === void 0 ? void 0 : choice.key) || i))) })), []);
    return ((0, jsx_runtime_1.jsx)(SelectInputContext_1.SelectInputContext.Provider, Object.assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsx)(Dropdown_1.Dropdown, Object.assign({ css: dropdownStyle, right: true, disabled: disabled, render: choicesRenderer }, dropdownProps, { onOpen: () => {
                var _a;
                setFocus(true);
                (_a = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.onOpen) === null || _a === void 0 ? void 0 : _a.call(dropdownProps);
            }, onClose: () => {
                var _a;
                setFocus(false);
                (_a = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.onClose) === null || _a === void 0 ? void 0 : _a.call(dropdownProps);
            } }, { children: (0, jsx_runtime_1.jsxs)(components_1.StyledInputWrap, Object.assign({ className: (0, utils_1.cls)({
                    'focus-visible': focus,
                }, className) }, { children: [label && ((0, jsx_runtime_1.jsx)(utils_2.Label, Object.assign({ css: labelStyle, inputKind: "text", className: (0, utils_1.cls)({
                            'focus-visible': focus,
                            'with-value': Boolean(value),
                        }), htmlFor: id, optional: Boolean(optional) }, (0, aria_1.aria)({ invalid: hasError, disabled }), { children: label }))), (0, jsx_runtime_1.jsxs)(Stack_1.Stack, { children: [(0, jsx_runtime_1.jsxs)(components_1.Relative, { children: [(0, jsx_runtime_1.jsx)(components_1.StyledInput, Object.assign({ id: id, value: choiceLabel, readOnly: true, className: (0, utils_1.cls)({
                                            'focus-visible': focus,
                                        }), onFocus: (ev) => {
                                            onFocus(ev.target.value);
                                            setFocus(true);
                                        }, onBlur: (ev) => {
                                            onBlur(ev.target.value);
                                            setFocus(false);
                                        } }, props, (0, aria_1.aria)({ invalid: hasError, success, disabled }))), (0, jsx_runtime_1.jsx)(components_1.SelectorArrow, {})] }), choiceLabel && removable ? ((0, jsx_runtime_1.jsx)(Button_1.Button, Object.assign({ kind: ['icon', 'transparent'], onClick: () => onChange('') }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgCloseMenu, {}) }))) : null] })] })) })) })));
};
exports.SelectInput = (0, react_1.forwardRef)((_a, ref) => {
    var { defaultValue, children: choices, dropdownCss } = _a, props = __rest(_a, ["defaultValue", "children", "dropdownCss"]);
    const render = (0, react_1.useMemo)(() => getSelectorRender(choices, defaultValue !== null && defaultValue !== void 0 ? defaultValue : '', dropdownCss), [choices, defaultValue, dropdownCss]);
    return ((0, jsx_runtime_1.jsx)(utils_2.InputController, Object.assign({}, props, { ref: ref, render: render, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '' })));
});
exports.SelectInput.Option = SelectInputOption_1.SelectInputOption;
exports.SelectInput.Button = SelectInputButton_1.SelectInputButton;
